/** Vettore 3D immutabile. Tutte le funzioni sono pure. */
export interface Vec3 {
  readonly x: number
  readonly y: number
  readonly z: number
}

export function vec3(x = 0, y = 0, z = 0): Vec3 {
  return { x, y, z }
}

export const ZERO: Vec3 = vec3(0, 0, 0)
export const UNIT_X: Vec3 = vec3(1, 0, 0)
export const UNIT_Y: Vec3 = vec3(0, 1, 0)
export const UNIT_Z: Vec3 = vec3(0, 0, 1)

export const add = (a: Vec3, b: Vec3): Vec3 => vec3(a.x + b.x, a.y + b.y, a.z + b.z)
export const sub = (a: Vec3, b: Vec3): Vec3 => vec3(a.x - b.x, a.y - b.y, a.z - b.z)
export const scale = (a: Vec3, s: number): Vec3 => vec3(a.x * s, a.y * s, a.z * s)
export const negate = (a: Vec3): Vec3 => vec3(-a.x, -a.y, -a.z)
export const dot = (a: Vec3, b: Vec3): number => a.x * b.x + a.y * b.y + a.z * b.z

export const cross = (a: Vec3, b: Vec3): Vec3 =>
  vec3(a.y * b.z - a.z * b.y, a.z * b.x - a.x * b.z, a.x * b.y - a.y * b.x)

export const lengthSq = (a: Vec3): number => a.x * a.x + a.y * a.y + a.z * a.z
export const length = (a: Vec3): number => Math.sqrt(lengthSq(a))
export const distance = (a: Vec3, b: Vec3): number => length(sub(a, b))

/** Normalizza. Il vettore nullo resta nullo: mai NaN nella simulazione. */
export function normalize(a: Vec3): Vec3 {
  const len = length(a)
  return len === 0 ? ZERO : scale(a, 1 / len)
}

export const lerp = (a: Vec3, b: Vec3, t: number): Vec3 => add(a, scale(sub(b, a), t))

/** Somma di una lista, usata per accumulare forze. */
export function sum(vs: readonly Vec3[]): Vec3 {
  let x = 0, y = 0, z = 0
  for (const v of vs) { x += v.x; y += v.y; z += v.z }
  return vec3(x, y, z)
}
